module.exports = __webpack_public_path__ + "static/media/reset-password-background.c33e7671.jfif";